export const formatText = (textToBeFormatted: string) => {
  if (textToBeFormatted) {
    if (textToBeFormatted.includes('_')) {
      // textToBeFormatted is separating words using Underscores example: hello_world
      return textToBeFormatted
        .replaceAll('_', ' ')
        .split(' ')
        .map((st) => st.charAt(0).toUpperCase() + st.slice(1).toLowerCase())
        .join(' ');
    } else if (/^([a-z]+)(([A-Z]([a-z]+))+)$/.test(textToBeFormatted)) {
      // textToBeFormatted is separating words using camelCase naming convention example: helloWorld
      return textToBeFormatted.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
        return str.toUpperCase();
      });
    } else {
      // textToBeFormatted doesn't have Underscores and not following camelCase naming convention
      // but the text might be all capitalized example: HELLO
      return textToBeFormatted.charAt(0).toUpperCase() + textToBeFormatted.slice(1).toLowerCase();
    }
  } else {
    // Handle the case where textToBeFormatted is undefined or null
    return '';
  }
};
